import fundaNowClient from '@/client/fundaNowClient'
import qs from 'query-string'
import HttpUtil from '@/util/HttpUtil'
import proxyClient from '@/client/proxyClient'

export default {
  getCurrentOffer() {
    return fundaNowClient.call({
      url: '/loans/offers/current/',
      method: 'GET',
    })
  },
  getLoansOffersCurrent(query = {}) {
    return fundaNowClient.call({
      url: `/loans/offers/current/?${qs.stringify(query)}`,
      method: 'GET',
      snakeToCamel: true
    })
  },
  getCurrentTempOffer() {
    return fundaNowClient.call({
      url: '/loans/temp-offers/current/',
      method: 'GET',
    })
  },
  getCurrentLoan() {
    return fundaNowClient.call({
      url: '/loans/current/',
      method: 'GET',
    })
  },
  getLoanAvailableTime() {
    return fundaNowClient.call({
      url: '/loans/available/time/',
      method: 'GET',
    })
  },
  getLoanContractAvailableTime() {
    return fundaNowClient.call({
      url: '/loans/contract/available/time/',
      method: 'GET',
    })
  },
  postLoan(offerId) {
    return fundaNowClient.call({
      url: '/loans/create/',
      method: 'POST',
      data: {
        offer: offerId
      }
    })
  },
  executeLoan() {
    return fundaNowClient.call({
      url: 'loans/execute',
      method: 'POST',
    })
  },
  getLoans(urlParams) {
    return fundaNowClient.call({
      url: 'loans/' + HttpUtil.jsonToQueryString(urlParams),
      method: 'GET'
    })
  },
  getLoanRepayments(uuid) {
    return fundaNowClient.call({
      url: '/loans/repayments/',
      method: 'GET',
      params: {
        uuid: uuid
      }
    })
  },
  getLoanRepaymentsHistory() {
    return fundaNowClient.call({
      url: '/loans/repayments/history/',
      method: 'GET'
    })
  },
  getLoanWaitingNumber() {
    return fundaNowClient.call({
      url: '/loans/waiting-number/',
      method: 'GET'
    })
  },
  getLoanCount() {
    return fundaNowClient.call({
      url: '/loans/count/',
      method: 'GET'
    })
  },
  registerFunding() {
    return fundaNowClient.call({
      url: '/loans/register-funding/',
      method: 'GET'
    })
  },
  closeFunding() {
    return fundaNowClient.call({
      url: '/loans/close-funding/',
      method: 'GET'
    })
  },
  executeFunding() {
    return fundaNowClient.call({
      url: '/loans/execute-funding/',
      method: 'GET'
    })
  },
  getInvestingAmount() {
    return fundaNowClient.call({
      url: '/loans/investing-amount/',
      method: 'GET'
    })
  },
  getClosedStore() {
    return fundaNowClient.call({
      url: '/loans/store-status/',
      method: 'GET'
    })
  },
  cancelLoan(uuid) {
    return fundaNowClient.call({
      url: `loans/${uuid}`,
      method: 'DELETE',
    })
  },
  getLoan(uuid) {
    return fundaNowClient.call({
      url: `loans/${uuid}`,
      method: 'GET',
    })
  },
  /**
   * 대출 uuid 로 대출신청정보 조회
   * @param {*} uuid
   * @returns
   */
  getLoansRequestByLoan(uuid) {
    return proxyClient.get(`/loans/${uuid}/request`)
  },
}
